<section class="sg-documents-container ml-3">
    <div class="row mx-0 margin-top-bottom mt-3">
        <div class="col-6">
            <h4 class="sg-page-title">Compliance and Regulations</h4>
        </div>
    </div>
</section>

<section class="sg-main cws-form-container complianceRegulations mb-5">
   <div class="pr-5 pl-5 pt-5 pb-3">
    <div id="complianceRegulationContent"></div> 
   </div>
   <!--
    <div class="pr-5 pl-5 pt-5 pb-3">
        <p>Caterpillar and Solar Turbines monitor global regulations and engage our business partners to
            ensure compliance with legislation that may affect Caterpillar business or that of its suppliers. The focus
            of this page is on the United States’ Conflict Minerals regulation, the European Union’s REACH
            (Registration, Evaluation and Authorization of Chemicals) regulation and RoHS (Restriction of Hazardous
            Substances) directive and Customs Supply Chain Security (C-TPAT). For compliance information and tools
            review the content and linked documents below.</p>
        <div class="mat-dialog-title mb-0 border-bottom  cws-header">Conflict Minerals</div>
        <p class="pt-3 pb-2">Conflict Mineral rules require all U.S. publicly traded companies, including Caterpillar
            Inc., to determine if the parts/assemblies in their products contain tin, tantalum, tungsten and/or gold
            (known as "Conflict Minerals"). If any Conflict Minerals are included in products they manufacture or
            contract to manufacture, the company must conduct a reasonable inquiry to determine if such Conflict
            Minerals originated in the Democratic Republic of the Congo (DRC) or any adjoining countries. As a result,
            Caterpillar is requiring its suppliers to provide sourcing information, including the smelters and refiners
            of Conflict Minerals in their supply chain, to determine whether the materials found in their products
            originated in the DRC or any adjoining country.</p>
        <div class="sg-read-more">
            <ul>
                <li>
                    <a href="https://www.caterpillar.com/en/company/sustainability/conflict-minerals.html"
                        target="_blank">Caterpillar Position Statement</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Conflict%20Minerals%20Reporting%20Training.pdf"
                        target="_blank">Conflict Minerals Training Opportunities</a>
                </li>
                <li>
                    <a href="https://www.conflict-minerals.com/" target="_blank">iPoint Conflict Minerals Platform -
                        iPCMP</a>
                </li>
                <li>
                    <a href="https://www.oecd.org/corporate/mne/mining.htm" target="_blank">OECD Guidelines</a>
                </li>
                <li>
                    <a href="https://www.sec.gov/news/press-release/2012-2012-163htm" target="_blank">SEC Ruling</a>
                </li>
                <li>
                    <a href="mailto:conflict_minerals@solarturbines.com" target="_blank">Solar's Conflict Minerals Contact</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/Supplier%20Conflict%20Minerals%20Letter.pdf"
                        target="_blank">Solar's Supplier Letter on Conflict Minerals</a>
                </li>
                <li>
                    <a href="https://supplierconnect.cat.com/q/" target="_blank">Supplier Development College</a>
                </li>
            </ul>
        </div>

        <div class="mat-dialog-title mb-0 border-bottom  cws-header">Customer Supply Chain Security (C-TPAT)</div>
        <p class="pt-3">As part of our overall commitment to ensure a secure supply chain, Caterpillar and Solar
            Turbines participate
            in a number of Global Supply Chain Security Programs including C-TPAT: Customs- Trade Partnership Against
            Terrorism (U.S.), AEO: Authorised Economic Operator (EU), NEEC: Nuevo Esquema de Empresas Certificadas
            (Mexico) and Linha Azul (Brazil). Caterpillar and Solar’s suppliers are critical partners in instituting
            effective security practices to mitigate the risk of loss, theft, and contraband smuggling that could
            potentially introduce terrorist and implements of terrorism into the global supply chain. The successful
            participation in these programs increases overall supply chain velocity and the ability to meet customer
            demand.</p>
        <p>The following links will help you understand our minimum requirements, definitions and best practices. Also
            provided are useful templates and training.</p>

        <div class="sg-gs-title mb-0 pb-3">C-TPAT Minimum Requirements</div>
        <div class="sg-read-more">
            <ul>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Minimum%20Requirements/CAT%20Supply%20Chain%20Security%20Program%20Guidelines.pdf"
                        target="_blank">CAT Supply Chain Security Program Guidelines</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/C-TPAT-Importer-Security-Criteria.html"
                        target="_blank">C-TPAT Importer Security Criteria</a>
                </li>
            </ul>
        </div>

        <div class="sg-gs-title mb-0 pb-3">C-TPAT Templates & Training</div>
        <div class="sg-read-more">
            <ul>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Definitions%20and%20Best%20Practices/C-TPAT%20and%20ISO%20Compliance.pdf"
                        target="_blank">C-TPAT and ISO Compliance</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Definitions%20and%20Best%20Practices/C-TPAT%20Introduction.pdf"
                        target="_blank">C-TPAT Introduction</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Definitions%20and%20Best%20Practices/Container%20Inspections%20Process.pdf"
                        target="_blank">Container Inspections Process</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Definitions%20and%20Best%20Practices/Supply%20Chain%20Security%20Best%20Practices%20Catalog.pdf"
                        target="_blank">Supply Chain Security Best Practices Catalog</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Definitions%20and%20Best%20Practices/Supply%20Chain%20Security%20Best%20Practices%20Catalog%20Addendum.pdf"
                        target="_blank">Supply Chain Security Best Practices Catalog Addendum</a>
                </li>
                <li>
                    <a href="https://www.brainshark.com/1/player/caterpillar?fb=1&r3f1=bb81ffaca0adf5e7b7f986e7b9a2adbab8e8e680eeaaa3f0bca7f4eb9ba5bbb1aae1abf7e7c6&custom=caterpillarc-tpattraining"
                        target="_blank">C-TPAT Security Awareness Training</a>
                </li>
            </ul>
        </div>

        <div class="sg-gs-title mb-0 pb-3">C-TPAT Useful Templates</div>
        <div class="sg-read-more">
            <ul>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Useful%20Templates/Container%20Inspection%20Checklist.pdf"
                        target="_blank">Container Inspection Checklist</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/C-TPAT%20Useful%20Templates/Seal%20Log%20Template.pdf"
                        target="_blank">Seal Log Template</a>
                </li>
            </ul>
        </div>

        <div class="mat-dialog-title mb-0 border-bottom  cws-header">Free Trade Agreements & Country of Origin</div>
        <p class="pt-3">Free Trade Agreements (FTAs) help companies compete more effectively in the global marketplace
            by eliminating
            tariffs applied to imported goods. Solar Turbines has provided these links to assist suppliers with the
            completion of the necessary certification documents.</p>
        <p>We thank you in advance for your cooperation and please understand that as the qualification process moves
            forward and as we receive eligibility information from other suppliers, our analysis may recommend that we
            seek additional part number certifications from your company that were not previously identified as
            requiring certification.</p>
        <div class="sg-read-more">
            <ul>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/NAFTA%20and%20Country%20of%20Origin%20Campaign%20Training%20Documents/Supplier%20Free%20Trade%20Agreement%20Campaign%20Overview.pdf
                    " target="_blank">Supplier Free Trade Agreement Campaign Overview</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/NAFTA%20and%20Country%20of%20Origin%20Campaign%20Training%20Documents/Supplier%20Job%20Aid%20-%20COO%20Campaign%20Navigation.pdf
                    " target="_blank">Supplier Job Aid - COO Campaign Navigation</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/NAFTA%20and%20Country%20of%20Origin%20Campaign%20Training%20Documents/Supplier%20Job%20Aid%20-%20Email%20Response%20-%20NAFTA%20COO.pdf
                    " target="_blank">Supplier Job Aid - Email Response - NAFTA COO</a>
                </li>
                <li>
                    <a href="https://solarsuppliers.solar.cat.com/gateway/docs/NAFTA%20and%20Country%20of%20Origin%20Campaign%20Training%20Documents/Supplier%20Job%20Aid%20-%20NAFTA%20Campaign%20Navigation.pdf
                    " target="_blank">Supplier Job Aid - NAFTA Campaign Navigation</a>
                </li>
            </ul>
        </div>

        <div class="mat-dialog-title mb-0 border-bottom  cws-header">Reach & ROHS</div>
        <p class="pt-3">European Union (EU) Regulation No. 1907/2006, the Registration, Evaluation, Authorisation and
            Restriction of Chemicals Regulation (known as 'REACH') bans, restricts, and or monitors the presence of
            certain chemical substances used in products intended for sale or distribution in the EU. The Restriction of
            Hazardous Substances Recast Directive (known as 'RoHS Recast'), 2011/65/EU, restricts the presence of
            certain chemicals used in electrical and electronic equipment intended for sale or distribution in the EU.
        </p>
        <p>To comply with EU Chemical Management regulations, Caterpillar and Solar Turbines must collect chemical
            substance data from our suppliers in the form of Materials Declarations. These Declarations assess whether
            or not purchased material and components contain substances of concern named in the regulations.</p>
        <p>More detailed information and supplier requirements to come.</p>
        </div>
    -->
</section>

<div class="sg-spinner" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>
